/**
 * seasonService.js — Season Pass + card-back unlocks.
 */
import { apiClient } from "./api";

export const seasonService = {
  getCurrentSeason: () => apiClient.get("/season-pass").then((r) => r.data),
  getProgress: () => apiClient.get("/season-pass/progress").then((r) => r.data),
  getCardBacks: () => apiClient.get("/card-backs").then((r) => r.data),
  setCardBack: (cardBackId) =>
    apiClient.post("/card-backs/set", { card_back_id: cardBackId }).then((r) => r.data),
};
